export const firebaseConfig = {
  apiKey: "AIzaSyCeEUp1z3Irq1VNOLALp4T1OtL1rJ7Wrpo",
  authDomain: "my-hive-90b6e.firebaseapp.com",
  databaseURL: "https://my-hive-90b6e.firebaseio.com",
  projectId: "my-hive-90b6e",
  storageBucket: "my-hive-90b6e.appspot.com",
  messagingSenderId: "718025274201",
  appId: "1:718025274201:web:82fa4599eedb7703efd248"
};
